export default "__VITE_ASSET__Ct7vFySK__"